import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AccountService } from '../account/shared/account.service';
import { ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Webshops } from '../../store/models/webshops';
import { Warenkorb } from '../../store/models/warenkorb';
import { WarenkorbsService } from '../../webshops/warenkorbs/shared/warenkorbs.service';
import { LayoutUtilsService, MessageType } from 'src/app/core/layout-utils.service';
import { event } from 'jquery';
import { endWith } from 'rxjs/operators';
import { formatDate } from '@angular/common';

@Component({
    selector: 'kkis-app-webshop-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss'],
    encapsulation: ViewEncapsulation.None //https://stackoverflow.com/questions/46403698/css-values-not-applying-on-dynamically-injected-html-div-elements-in-angular-4
})
export class WebshopAccountComponent implements OnInit {
    
    @Output()
    numberWarenkorbItems: EventEmitter<number> = new EventEmitter<number>();

    receipts: Webshops.IReceiptDto[];
       
    //isLoading: boolean = true;
    
    // Search
    search: string = "";

    constructor(
        private router: Router,
        private accountsService: AccountService,
        private warenkorbsService: WarenkorbsService,
        private layoutUtilsService: LayoutUtilsService
    ) {

    }

    
    ngOnInit(): void {

        //this.isLoading = true;

        console.log('ngOnInit');

        this.loadreceipts("A",false);
        this.loadreceipts("A",true);

        this.loadreceipts("B",false);
        this.loadreceipts("B",true);

        this.loadreceipts("L",false);
        this.loadreceipts("L",true);

    }

    ngAfterViewInit() {

        console.log('ngAfterViewInit');

        document.getElementById('div_account').addEventListener('click', (event) => {

        //document.addEventListener('click', (event) => {
            //alert(event.target)    
            //console.log(event.target);

            var el = event.target;

            if ($(el).hasClass('col_expand')) {

                $(el).toggleClass('expanded');
                $(el).parents('.receipt').find('.cont_pos_header').toggleClass('hidden');
                $(el).parents('.receipt').find('.position').toggleClass('hidden');

            } else if ($(el).hasClass('col_rec_wk')) {
                //Alle Artikel des Beleges in den Warenkorb legen
                this.onAddReceiptToWarenkorb(event);

                //funktioniert
                /*
                var later_this = this;

                $(el).parents('.receipt').find('.position').each(function () {
                    
                    let anzahl = $(this).data('anzahl');
                    let id;
                    if ($(this).data('matrixid')) {
                        id = $(this).data('matrixid');
                    } else {
                        id = $(this).data('id');
                    }
                    let ismatrixArtikel = ($(this).data('matrixid') ? true : false);

                    later_this.onAddToWarenkorb(id, anzahl, ismatrixArtikel);

                })
                */

            } else if ($(el).hasClass('col_pos_wk')) {
                //Position in Warenkorb legen
                //Menge 1 oder Menge aus Position? abfragen
                
                let anzahl = $(el).parents('.position').data('anzahl');
                let id;
                if ($(el).parents('.position').data('matrixid')) {
                    id = $(el).parents('.position').data('matrixid');
                } else {
                    id = $(el).parents('.position').data('id');
                }
                let ismatrixArtikel = ($(el).parents('.position').data('matrixid') ? true : false);

                this.onAddToWarenkorb(id, anzahl, ismatrixArtikel);

            }
        });

        //this.isLoading = false;
    }

    loadreceipts(belegart:string, archive:boolean) {

        this.accountsService.getReceiptlistAsync(belegart, archive).subscribe(res => {
            
            //console.log(res);

            this.receipts = res;           

            console.log(this.receipts);
            
            if (this.receipts.length > 0) {
                //einblenden!!!

                $('#div_'+belegart).show();

                var cont_receipt = "";
                
                //receipt col header
                var cont_receipt_header = "<div class='cont_receipt_header'>";
                cont_receipt_header +="<div class='col_space'></div>";
                cont_receipt_header +="<div class='receipt_col_h col_belegnr'>Beleg-Nr.</div>";
                cont_receipt_header +="<div class='receipt_col_h col_date'>Datum</div>";
                cont_receipt_header +="<div class='receipt_col_h col_summe_netto'>Summe netto</div>";
                cont_receipt_header +="<div class='receipt_col_h col_summe_brutto'>Summe brutto</div>";
                                                
                cont_receipt_header +="</div>";


                for (var i = 0; i < this.receipts.length; i++) {
                    //console.log('i: ' + i);

                    cont_receipt += "<div class='receipt' data-belegnr='"+this.receipts[i].belegNr+"' data-search='$xxx$'>";

                    cont_receipt += "<div style='display: flow-root;'>";

                    cont_receipt += "<div class='receipt_cols'>";
                    cont_receipt += "<div class='col_expand'></div>";
                    cont_receipt += "<div class='receipt_col col_belegnr'>"+this.receipts[i].belegNr + '-' + this.receipts[i].belegNrZusatz+"</div>";
                    
                    let mydate = new Date(this.receipts[i].datum);
                    cont_receipt += "<div class='receipt_col col_date'>"+mydate.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })+"</div>";

                    cont_receipt += "<div class='receipt_col col_summe_netto'>"+this.receipts[i].summe_netto.toFixed(2)+"€</div>";
                    cont_receipt += "<div class='receipt_col col_summe_brutto'>"+this.receipts[i].summe_brutto.toFixed(2)+"€</div>"; 

                    cont_receipt += "</div>";

                    cont_receipt += "<div class='col_rec_wk flaticon2-shopping-cart-1' title='ALLE Artikel in den Warenkorb legen'></div>";
                    cont_receipt += "</div>";

                    if (this.receipts[i].positionen.length > 0) {

                        console.log('poscount: '+this.receipts[i].positionen.length);

                        var cont_pos = "";
                        var cont_pos_header = "<div class='cont_pos_header hidden'>";
                        cont_pos_header +="<div class='col_pos_posnr'>Nr.</div>";
                        cont_pos_header +="<div class='col_pos_anzahl'>Anzahl</div>";
                        cont_pos_header +="<div class='col_pos_artnr'>Art.-Nr.</div>";
                        cont_pos_header +="<div class='col_pos_artl'>Bezeichnung</div>";
                        cont_pos_header +="<div class='col_pos_preis_2 h'>Preis</div>";
                        cont_pos_header +="<div class='col_pos_preis'>Gesamtpreis</div>";

                        if (belegart == "B") {
                            cont_pos_header +="<div class='col_pos_anzahl'>Anzahl</div>";
                            cont_pos_header +="<div class='col_pos_geliefert'>geliefert</div>";
                            cont_pos_header +="<div class='col_pos_rest'>Rest</div>";
                            cont_pos_header +="<div class='col_pos_termin'>Termin</div>";
                        }   

                        cont_pos_header +="</div>";

                        var cont_search = "";
                        var color_class = "";

                        for (let i_pos = 0; i_pos < this.receipts[i].positionen.length; i_pos++) {
                            //console.log("postyp: "+this.receipts[i].positionen[i_pos].typ);
                            var tp = (this.receipts[i].positionen[i_pos].typ == null || this.receipts[i].positionen[i_pos].typ == "" ? true : false);
                            //console.log("tp: "+tp);
                            cont_pos += "<div class='position hidden'";
                            
                            cont_pos += " data-id='"+this.receipts[i].positionen[i_pos].artikelId+"'";
                            if (this.receipts[i].positionen[i_pos].matrixId > 0) {
                                cont_pos += " data-matrixid='"+this.receipts[i].positionen[i_pos].matrixId+"'";
                            }                            
                            cont_pos += " data-anzahl='"+this.receipts[i].positionen[i_pos].anzahl+"'";
                            cont_pos += " data-artnr='"+this.receipts[i].positionen[i_pos].artNr+"'";
                            cont_pos += " data-artl='"+this.receipts[i].positionen[i_pos].artL+"'";
                            cont_pos += " data-textpos='"+tp+"'";
                            
                            cont_pos += ">";
                            
                            cont_pos += "<div>";

                            cont_pos += "<div class='pos_cols'>";

                            if (tp == false) {
                            
                                //normale Materialposition
                                cont_pos += "<div class='pos_col col_pos_posnr'>" + this.receipts[i].positionen[i_pos].position + "</div>";
                                cont_pos += "<div class='pos_col col_pos_anzahl'>" + this.receipts[i].positionen[i_pos].anzahl + "</div>";
                                cont_pos += "<div class='pos_col col_pos_artnr'>" + this.receipts[i].positionen[i_pos].artNr + "</div>";

                                cont_pos += "<div class='pos_col'>";
                                cont_pos += "<div class='pos_col_inner col_pos_artl'>" + this.receipts[i].positionen[i_pos].artL + "</div>";
                                if (this.receipts[i].positionen[i_pos].matrixId > 0) {
                                    cont_pos += "<div class='pos_col col_pos_matrix'>" + this.receipts[i].positionen[i_pos].farbe + "/" + this.receipts[i].positionen[i_pos].groesse + "</div>";
                                }
                                cont_pos += "</div>";

                                cont_pos += "<div class='pos_col col_pos_preis_2'>" + (this.receipts[i].positionen[i_pos].preis_2 == null ? "" : this.receipts[i].positionen[i_pos].preis_2.toFixed(2) + "€") + "</div>";
                                cont_pos += "<div class='pos_col col_pos_preis'>" + this.receipts[i].positionen[i_pos].preis.toFixed(2) + "€</div>";

                                if (belegart == "B") {
                                    cont_pos += "<div class='pos_col col_pos_anzahl'>" + this.receipts[i].positionen[i_pos].anzahl + "</div>";
                                    cont_pos += "<div class='pos_col col_pos_geliefert'>" + (this.receipts[i].positionen[i_pos].abrufDiff == null ? "0" : this.receipts[i].positionen[i_pos].abrufDiff) + "</div>";

                                    color_class = this.receipts[i].positionen[i_pos].abrufRest > 0 ? "red" : "green";

                                    cont_pos += "<div class='pos_col col_pos_rest "+ color_class +"'>" + (this.receipts[i].positionen[i_pos].abrufRest == null ? "0" : this.receipts[i].positionen[i_pos].abrufRest) + "</div>";

                                    cont_pos += "<div class='pos_col col_pos_termin'>";
                                    if (this.receipts[i].positionen[i_pos].bestellPositionen != null) {

                                        for (var i_bestpos = 0; i_bestpos < this.receipts[i].positionen[i_pos].bestellPositionen.length; i_bestpos++) { 
                                        
                                            const termin = new Date(this.receipts[i].positionen[i_pos].bestellPositionen[i_bestpos].termin);
                                        
                                            cont_pos += "<div>"+ formatDate(termin, 'dd.MM.yyyy', 'de_DE') +" ("+ this.receipts[i].positionen[i_pos].bestellPositionen[i_bestpos].anzahl +")</div>";

                                        }

                                    }
                                    cont_pos += "</div>";
                                }
                            
                            } else {

                                //Textposition/Abgerufen aus...
                                cont_pos += "<div class='pos_col col_pos_artl'>" + this.receipts[i].positionen[i_pos].artL + "</div>";

                            }

                            cont_pos += "</div>";

                            cont_pos += "<div class='col_pos_wk flaticon2-shopping-cart-1' title='Artikel in den Warenkorb legen'></div>";

                            cont_pos += "</div>";

                            cont_pos += "</div>";

                            cont_search += (cont_search.length >= 0 ? ";" : "");
                            cont_search += this.receipts[i].positionen[i_pos].artNr + ";" +this.receipts[i].positionen[i_pos].artL;

                        }
                        
                        cont_receipt += cont_pos_header + cont_pos;
                        cont_receipt = cont_receipt.replace("$xxx$",cont_search);
                        
                    }

                    cont_receipt += "</div>";

                }

                if (archive == true) {
                    $('.receipt_' + belegart + '.archive').append(cont_receipt_header + cont_receipt);
                } else {
                    $('.receipt_' + belegart + '.open').append(cont_receipt_header + cont_receipt);
                }
     
            }

            //$('#div_account').html(this.receipts[0].belegNr+','+this.receipts[1].belegNr);
            

            //console.log(this.receipts[0].belegNr);
            //console.log(this.receipts[1].belegNr);

        });

    }

    onAddToWarenkorb(kennung: number, menge: number, isMatrixArtikel: boolean = false) {

        const _addPosMessage = "Der Artikel wurde zum Warenkorb hinzugefügt!";

        let newPosition = {} as Warenkorb.IAddPositionDto;

        newPosition.artikelKennung = kennung;
        newPosition.menge = menge;
        newPosition.isMatrixArtikel = isMatrixArtikel;

        this.warenkorbsService.addPosition(newPosition).subscribe(res => {
            if (res != null) {
                console.log('anzahlpos: '+res.warenkorbPositionen.length);
                this.numberWarenkorbItems.emit(res.warenkorbPositionen.length);
                this.layoutUtilsService.showActionNotification(_addPosMessage, MessageType.Update);
            }

        });

    }

    onAddReceiptToWarenkorb(event) {
        //ganzen Beleg hinzufügen
        const _addPosMessage = "Der/die Artikel wurde(n) zum Warenkorb hinzugefügt!";


        let newArtikels = {} as Warenkorb.IWarenkorbArtikelsDto;
        newArtikels.positionen = [];
    

        $(event.target).parents('.receipt').find('.position').each(function () {

            let kennung = $(this).attr('data-id');
            let menge = $(this).attr('data-anzahl');
            
            //let ismatrixArtikel = $(this).attr('data-matrixid');

            let newPosition = {} as Warenkorb.IAddPositionDto;

            newPosition.artikelKennung = parseInt(kennung);
            newPosition.menge = parseFloat(menge);
            //newPosition.isMatrixArtikel = isMatrixArtikel;

            newArtikels.positionen.push(newPosition);
           

            /*
        export interface IWarenkorbArtikelListDto {


        let newPosition = {} as Warenkorb.IAddPositionDto;

        newPosition.artikelKennung = kennung;
        newPosition.menge = menge;
        newPosition.isMatrixArtikel = isMatrixArtikel;

        this.warenkorbsService.addReceipt(newPosition).subscribe(res => {
            if (res != null) {
                console.log('anzahlpos: '+res.warenkorbPositionen.length);
                this.numberWarenkorbItems.emit(res.warenkorbPositionen.length);
                this.layoutUtilsService.showActionNotification(_addPosMessage, MessageType.Update);
            }
*/
        });
        
        this.warenkorbsService.addPositions(newArtikels).subscribe(res => {
            if (res != null) {
                console.log('anzahlpos: '+res.warenkorbPositionen.length);
                this.numberWarenkorbItems.emit(res.warenkorbPositionen.length);
                this.layoutUtilsService.showActionNotification(_addPosMessage, MessageType.Update);
            }

        });

        console.log('newArtikels: '+newArtikels.positionen);
  
    }

    onSearch() {
        console.log('search: '+this.search);

        $('.receipt').show();

        //Filter function
        if (this.search != '') {

            let st = (this.search).trim().toUpperCase();

            $('.receipt').filter(function() {

                //
                return (!(($(this).attr('data-belegnr').toUpperCase().includes(st)) || ($(this).attr('data-search').toUpperCase().includes(st))));

            }).hide();

            //$(elem_filterparent).parents('.bottom_art_cont').find('.m_container').filter(function () {
            //    return (!($(this).attr("data-artnr").includes(st) || $(this).attr("data-x").includes(st) || $(this).attr("data-y").includes(st)));
            //}).hide();
        }

    }

    onKeyup(event) {
        console.log(event);

        if (event.keyCode != 13) {
            this.onSearch();
        }
    }

    getNumberWarenkorbItems(event)
    {
        this.numberWarenkorbItems.emit(event);
    }

    goBack() {
        this.router.navigate(['/articles'], {
            queryParams: {
                showWarenkorb: false,
                showAdvertise: false
            }
        });
    }
}
